import React, { Component } from "react";
import axios from "../../axiosIn";

export class Exportar extends Component {
  async ExportarXLS() {
    axios
      .post("Registro/Exportar", null, {
        headers: {
          "Content-Disposition": "attachment; filename=ReporteParticipantes.xlsx",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ReporteParticipantes.xlsx");
        document.body.appendChild(link);
        link.click();
				window.location = `/#/Login/Menu`;
      })
      .catch((error) => console.log(error));
  }

  render() {
    this.ExportarXLS();
    return <div>Exportando datos...</div>;
  }
}
